import * as React from 'react';

import EntityAvatar from 'components/entity/entity-avatar/EntityAvatar';
import EntityName from 'components/entity/entity-name/EntityName';
import MetricsChannelsAdvanced from 'components/metrics/channels-advanced/MetricsChannelsAdvanced';
import Tooltip from 'components/Tooltip';

import ContentCardDetailsReactions from './reactions/ContentCardDetailsReactions';

import { __t, applyTranslations } from 'utils/language';
import { getEntityFromProfile } from 'utils/view';
import { prepareDataForMetricsChannelsAdvanced } from 'utils/metrics';

import './content-card-details.scss';

import type { ChannelTypes, InfluencerCommon } from 'types';
import type {
  ContentCardContentType,
  ContentCardCreatorProfile,
  ContentCardItem
} from 'components/cards/content-card/types';
import type {
  ReportingMetaInfoIGStorySnippetType
} from 'modules/reporting/types';

applyTranslations(require('components/cards/content-card/shared/content-card-shared.i18n.json'));

type Props = {
  item: ContentCardItem,
  cardType: ContentCardContentType,
  creatorProfile: InfluencerCommon | Partial<ContentCardCreatorProfile>,
  channel: ChannelTypes,
  igStorySnippetType?: ReportingMetaInfoIGStorySnippetType
};

const SHARED_MSG_KEY = 'content_card_shared';

const ContentCardDetails = ({
  item,
  cardType,
  creatorProfile,
  channel,
  igStorySnippetType
}: Props): JSX.Element => {
  const entity = getEntityFromProfile(creatorProfile);
  const metricsChannels = prepareDataForMetricsChannelsAdvanced(creatorProfile, channel, item.metrics);

  return (
    <div className="content-card-details">
      <div className="content-card-details__creator">
        <div className="content-card-details__avatar">
          <Tooltip
            message={__t(`${SHARED_MSG_KEY}.tooltips.view_profile`)}
            width="auto-compact"
            classNameWrapper="content-card-details__tooltip"
          >
            <EntityAvatar
              bordered
              openInNewTab
              entity={entity}
              link={entity?.url}
              customSize={{
                width: 48,
                height: 48
              }}
            />
          </Tooltip>
        </div>
        <div className="content-card-details__details">
          <div className="content-card-details__name">
            <Tooltip
              message={__t(`${SHARED_MSG_KEY}.tooltips.view_profile`)}
              width="auto-compact"
              classNameWrapper="content-card-details__tooltip"
            >
              <EntityName
                openInNewTab
                entity={entity}
                link={entity?.url}
                size="small"
              />
            </Tooltip>
          </div>
          <div className="content-card-details__metrics">
            <MetricsChannelsAdvanced
              channels={[metricsChannels]}
              showChannels={[channel]}
            />
          </div>
        </div>
      </div>
      <ContentCardDetailsReactions
        item={item}
        cardType={cardType}
        igStorySnippetType={igStorySnippetType}
      />
    </div>
  );
};

export default ContentCardDetails;
